import {
  createModal,
  IconClose,
  IconFullscreenExit,
  IconFullscreenOpen,
  ListItem,
  ModalPopover,
  ModalPopoverAnchor,
  ModalPopoverDirection,
  ModalPopOverParentSelector,
  spacing,
  styled,
  useModal,
  useTranslation,
} from '@lessonup/ui-components';
import React, { useCallback } from 'react';

export interface PlayerBarBottomSettingsProps {
  direction: ModalPopoverDirection;
  modalAnchor: ModalPopoverAnchor;
  parentSelector: ModalPopOverParentSelector;
  onClose: () => void;
  visibleSettings?: {
    closeLesson?: boolean;
    toggleFullscreen?: boolean;
  };
  isFullscreen?: boolean;
  onToggleFullscreen?: () => void;
}

export const PlayerBarBottomMenu = createModal(
  ({
    direction,
    modalAnchor,
    parentSelector,
    onClose,
    visibleSettings = {
      closeLesson: true,
      toggleFullscreen: true,
    },
    isFullscreen,
    onToggleFullscreen,
  }: PlayerBarBottomSettingsProps) => {
    const modal = useModal();
    const { t } = useTranslation('player');

    const handleToggleFullscreen = useCallback(() => {
      if (onToggleFullscreen) {
        window.requestAnimationFrame(() => {
          onToggleFullscreen();
        });
      }
      modal.hide();
    }, [modal, onToggleFullscreen]);

    return (
      <ModalPopover
        direction={direction}
        modalAnchor={modalAnchor}
        parentSelector={parentSelector}
        modal={modal}
        contentLabel="Player menu"
      >
        <ModalPopoverBody>
          {visibleSettings.closeLesson && (
            <ListItem text={t('labels.close')} onClick={onClose} aria-label={t('labels.close')} icon={<IconClose />} />
          )}
          {visibleSettings.toggleFullscreen && isFullscreen !== undefined && (
            <ListItem
              text={isFullscreen ? t('labels.exitFullscreen') : t('labels.fullscreen')}
              onClick={handleToggleFullscreen}
              aria-label={isFullscreen ? t('labels.exitFullscreen') : t('labels.fullscreen')}
              icon={isFullscreen ? <IconFullscreenExit /> : <IconFullscreenOpen />}
            />
          )}
        </ModalPopoverBody>
      </ModalPopover>
    );
  }
);

const ModalPopoverBody = styled.div`
  min-width: 200px;
  max-width: 256px;
  padding: ${spacing.size12};
`;
